import { t } from '@lingui/macro';

import type { SortingTypes } from '@decisiv/ui-components/lib/components/Table';
import { Column } from '@decisiv/ui-components/lib/components/Table/types';

import { sortFactory } from 'utils/sortFactory';
import type { ManagedDepotsType } from '.';
import OemSegmentNameCell from './Cells/OemSegmentNameCell';
import TeamNameCell from './Cells/TeamNameCell';
import AccountNameCell from './Cells/AccountNameCell';
import AccountIdCell from './Cells/AccountIdCell';
import NameCell from './Cells/NameCell';
import FmsIdCell from './Cells/FmsIdCell';
import AssetsEnabledCell from './Cells/AssetsEnabledCell';
import CityCell from './Cells/CityCell';
import StateCell from './Cells/StateCell';

interface GenerateColumnsParams {
  onSort: (fieldName: string, direction: SortingTypes) => void;
  amountOfOemSegmentsManaged: number;
}

export const generateColumns = ({
  onSort,
  amountOfOemSegmentsManaged,
}: GenerateColumnsParams) => {
  return [
    ...(amountOfOemSegmentsManaged > 1
      ? [
          {
            name: 'oem_segment',
            title: t`OEM Segment Name`,
            DataCell: OemSegmentNameCell,
            sortBy: sortFactory('OEM_SEGMENT_NAME', onSort),
          },
        ]
      : []),
    {
      name: 'team',
      title: t`Team Name`,
      DataCell: TeamNameCell,
      sortBy: sortFactory('SENTINEL_TEAM_NAME', onSort),
    },
    {
      name: 'account',
      title: t`Account Name`,
      DataCell: AccountNameCell,
      sortBy: sortFactory('PLATFORM_ACCOUNT', onSort),
    },
    {
      name: 'accountId',
      title: t`Account ID`,
      DataCell: AccountIdCell,
      sortBy: sortFactory('PLATFORM_ACCOUNT_ID', onSort),
    },
    {
      name: 'name',
      title: t`Depot Name`,
      DataCell: NameCell,
      sortBy: sortFactory('NAME', onSort),
    },
    {
      name: 'fmsId',
      title: t`FMS ID`,
      DataCell: FmsIdCell,
      sortBy: sortFactory('CUSTOMERS_NUMBER', onSort),
    },
    {
      name: 'assets',
      title: t`Assets`,
      DataCell: AssetsEnabledCell,
      sortBy: sortFactory('ENABLED_ASSET_COUNT', onSort),
    },
    {
      name: 'city',
      title: t`City`,
      DataCell: CityCell,
      sortBy: sortFactory('CITY', onSort),
    },
    {
      name: 'state',
      title: t`State`,
      DataCell: StateCell,
      sortBy: sortFactory('STATE', onSort),
    },
  ] satisfies Column<ManagedDepotsType>[];
};
